import React from "react";
import Icon from "../../../components/AppIcon";
import { CITIES, SERVICES, ORANGE, NAVY } from "./coverageData";

const glass = {
  background: "rgba(255,255,255,.06)",
  border: "1px solid rgba(255,255,255,.15)",
  backdropFilter: "blur(6px)",
};

export default function CoverageRegions({ activeCityKey, setActiveCityKey }) {
  return (
    <div className="space-y-5">
      {/* Panel título */}
      <div className="rounded-2xl p-5" style={glass}>
        <div className="flex items-center gap-3">
          <div
            className="w-9 h-9 rounded-lg grid place-items-center"
            style={{ background: "rgba(255,255,255,.12)" }}
          >
            <Icon name="MapPin" size={16} className="text-white" />
          </div>
          <div>
            <h3 className="font-orbitron text-white text-lg">Ciudades Cubiertas</h3>
            <p className="font-body text-white/80 text-xs">
              Oficina Principal: Bogotá. Operación en capitales y ciudades clave.
            </p>
          </div>
        </div>
      </div>

      {/* Lista de ciudades con selección */}
      <div className="rounded-2xl p-4" style={glass}>
        <ul className="space-y-2">
          {CITIES.map((c) => {
            const active = c.key === activeCityKey;
            return (
              <li key={c.key}>
                <button
                  onClick={() => setActiveCityKey(c.key)}
                  className="w-full text-left rounded-xl px-4 py-3 transition flex items-start justify-between gap-3"
                  style={{
                    color: active ? "#0A1420" : "#e9eef7",
                    background: active ? "#e9eef7" : "rgba(255,255,255,.08)",
                    border: "1px solid rgba(255,255,255,.15)",
                  }}
                >
                  <div>
                    <div className="font-body font-semibold">{c.label}</div>
                    <div className="text-xs opacity-80">
                      {c.tag} · Tiempo de respuesta: {c.responseHrs}h
                    </div>
                  </div>
                  <span
                    className="px-2 py-0.5 rounded-full text-[11px]"
                    style={{
                      background: `linear-gradient(90deg, ${NAVY}, ${ORANGE})`,
                      color: "white",
                    }}
                  >
                    {c.services.length} servicios
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Mini métricas */}
      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-2xl p-5" style={glass}>
          <div className="font-orbitron text-white text-3xl">24/7</div>
          <div className="font-body text-white/80 text-sm">Atención emergencias</div>
        </div>
        <div className="rounded-2xl p-5" style={glass}>
          <div className="font-orbitron text-white text-3xl">100%</div>
          <div className="font-body text-white/80 text-sm">Transparencia</div>
        </div>
      </div>
    </div>
  );
}
